module.exports = __webpack_public_path__ + "img/sl.5b1acf74.svg";